import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Flex from '@wix/da-ds/pkg/Flex';

import s from './WidgetHeaderMobile.scss';

export interface Props {
  header: string | React.ReactNode;
  subHeader?: string;
  count?: number | string;
  extras?: React.ReactNode | React.ReactNode[];
  extrasWhenSticky?: React.ReactNode | React.ReactNode[];
  isSticky?: boolean;
  className?: string;
  rootClassName?: string;
  isWide?: boolean;
}

const WidgetHeaderMobile: React.FC<Props> = ({
  className,
  isSticky,
  header,
  subHeader,
  count,
  extras,
  extrasWhenSticky,
  rootClassName,
  isWide = false,
}) => {
  const shouldRenderAsHeading = !!header;
  const Tag = shouldRenderAsHeading ? Heading : 'div';
  const renderInner = (isStuck = false) => (
    <Flex
      direction="column"
      alignItems="flex-start"
      className={classnames(
        s['root'],
        isStuck && s['is-stuck'],
        isWide && s['is-wide'],
        rootClassName
      )}
    >
      <Flex
        direction="row"
        alignItems="center"
        fullWidth
        justifyContent="space-between"
      >
        <Tag className={s['header']}>
          {header}
          {!!count && (
            <span className={s['count']}>{shortenNumber(count)}</span>
          )}
        </Tag>
        {extras}
        {isStuck && extrasWhenSticky}
      </Flex>
      {subHeader && <div className={s['subheader']}>{subHeader}</div>}
    </Flex>
  );

  return (
    <div className={classnames(s['wrapper'], className)}>{renderInner()}</div>
  );
};
WidgetHeaderMobile.displayName = 'WidgetHeaderMobile';

export default WidgetHeaderMobile;
